import { getQueryStringParams } from '../config/helpers/getQueryStringParams';

export interface UtmParameters {
  utm_source?: string;
  utm_medium?: string;
  utm_channel?: string;
  utm_campaign?: string;
  utm_term?: string;
  utm_content?: string;
}

const isUtmParamKey = (key: string): key is keyof UtmParameters => {
  return /^utm_(source|medium|channel|campaign|term|content)/.test(key);
};

/**
 * Extracts {@link https://en.wikipedia.org/wiki/UTM_parameters|utm parameters} from the current url query string.
 */
const getUtmParams = (): UtmParameters => {
  const params = getQueryStringParams() as Record<string, string>;

  return Object.keys(params).reduce<Partial<UtmParameters>>(
    (utmParams, key) => {
      if (isUtmParamKey(key)) {
        utmParams[key] = params[key];
      }

      return utmParams;
    },
    {}
  );
};

export { getUtmParams };
